module.exports = __webpack_public_path__ + "static/media/our-brands-peterelish.e56898ff.svg";